import { apiRequest } from "@core/services/api/apiRequest";
import { VIDEO_API } from "../videoMeeting.constants";
import type { VideoRoomHeartbeatResponse } from "../videoMeeting.types";
import { getTrackingMetadata } from "./getTrackingMetadata";

export const sendVideoMeetingHeartbeat = async (
  meetingId: string,
  userName: string,
  user: { id: number } | null
): Promise<VideoRoomHeartbeatResponse> => {
  const timestamp = Math.floor(Date.now() / 1000);
  const heartbeatKey = `${meetingId}_${userName}_${timestamp}`;
  const trackingMetadata = getTrackingMetadata(user);

  return apiRequest(VIDEO_API.HEARTBEAT, "POST", {
    heartbeat_key: heartbeatKey,
    ...trackingMetadata,
  });
};
